/* Riverwell page produit (rwpp-*) : comportements partages.
   Chaque fonction s'initialise sur ses elements [data-rwpp-*] et se relance quand l'editeur recharge une section. */
(function () {
  if (window.__rwppLoaded) return;
  window.__rwppLoaded = true;

  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function once(el, key) { if (el['__rwpp_' + key]) return false; el['__rwpp_' + key] = true; return true; }
  function headerOffset() {
    var h = document.querySelector('.header-wrapper, header.header, #shopify-section-header, [id*="__header"]');
    return h ? Math.min(h.getBoundingClientRect().height, 140) + 12 : 80;
  }

  /* liens d'ancre doux */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-rwpp-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').split('#')[1];
    var t = id && document.getElementById(id);
    if (!t) return;
    e.preventDefault();
    window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - headerOffset(), behavior: 'smooth' });
  });

  /* accordeons : un seul ouvert a la fois */
  function accordions(ctx) {
    $$('[data-rwpp-single]', ctx).forEach(function (g) {
      if (!once(g, 'acc')) return;
      g.addEventListener('toggle', function (e) {
        var d = e.target;
        if (d.tagName !== 'DETAILS' || !d.open) return;
        $$('details', g).forEach(function (o) { if (o !== d) o.open = false; });
      }, true);
    });
  }

  /* galerie produit */
  function gallery(ctx) {
    $$('[data-rwpp-gal]', ctx).forEach(function (gal) {
      if (!once(gal, 'gal')) return;
      var thumbs = $$('[data-rwpp-thumb]', gal), main = gal.querySelector('[data-rwpp-main]'), i = 0;
      if (!main || !thumbs.length) return;
      function show(n) {
        i = (n + thumbs.length) % thumbs.length;
        var t = thumbs[i];
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        thumbs.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
        // La bande de miniatures defile : sans cela, passer a l'image 7 avec
        // les fleches laisserait sa miniature hors de l'ecran.
        if (t.scrollIntoView) {
          try { t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' }); }
          catch (e) { t.scrollIntoView(false); }
        }
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      $$('[data-rwpp-gal-step]', gal).forEach(function (b) {
        b.addEventListener('click', function () { show(i + Number(b.getAttribute('data-rwpp-gal-step'))); });
      });
      var x0 = null, box = main.parentNode;
      box.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
        x0 = null;
      }, { passive: true });
    });
  }

  /* carrousel des resultats */
  function results(ctx) {
    $$('[data-rwpp-res]', ctx).forEach(function (sec) {
      if (!once(sec, 'res')) return;
      var tr = sec.querySelector('.rwpp-res__track'), pv = sec.querySelector('[data-rwpp-prev]'), nx = sec.querySelector('[data-rwpp-next]');
      var dotsBox = sec.querySelector('.rwpp-dots');
      if (!tr) return;
      var dots = [];
      function pages() { return Math.max(1, Math.min(6, Math.ceil(tr.scrollWidth / Math.max(1, tr.clientWidth)))); }
      function buildDots() {
        if (!dotsBox) return;
        var n = pages();
        if (dots.length === n) return;
        dotsBox.innerHTML = '';
        dots = [];
        for (var k = 0; k < n; k++) {
          var b = document.createElement('button');
          b.type = 'button'; b.setAttribute('aria-label', 'Slide ' + (k + 1));
          (function (k) { b.addEventListener('click', function () { tr.scrollTo({ left: (tr.scrollWidth - tr.clientWidth) * k / Math.max(1, n - 1), behavior: 'smooth' }); }); })(k);
          dotsBox.appendChild(b); dots.push(b);
        }
        dotsBox.parentNode.hidden = n < 2;
      }
      function upd() {
        buildDots();
        var max = tr.scrollWidth - tr.clientWidth, p = max > 0 ? tr.scrollLeft / max : 0, on = Math.round(p * (dots.length - 1));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === on); });
        if (pv) pv.classList.toggle('is-off', tr.scrollLeft < 4);
        if (nx) nx.classList.toggle('is-off', tr.scrollLeft > max - 4);
      }
      function step() { var c = tr.querySelector('.rwpp-rc'); return c ? c.offsetWidth + 16 : 376; }
      tr.addEventListener('scroll', upd, { passive: true });
      window.addEventListener('resize', upd);
      if (pv) pv.addEventListener('click', function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (nx) nx.addEventListener('click', function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); });
      var drag = null;
      tr.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; drag = { x: e.clientX, l: tr.scrollLeft }; tr.style.scrollSnapType = 'none'; tr.style.cursor = 'grabbing'; });
      tr.addEventListener('pointermove', function (e) { if (drag) tr.scrollLeft = drag.l - (e.clientX - drag.x); });
      function end() { if (!drag) return; drag = null; tr.style.scrollSnapType = ''; tr.style.cursor = ''; }
      tr.addEventListener('pointerup', end); tr.addEventListener('pointerleave', end);
      upd();
    });
  }

  /* compteurs des stats, rejoues a chaque passage */
  function stats(ctx) {
    $$('[data-rwpp-stats]', ctx).forEach(function (box) {
      if (!once(box, 'stats')) return;
      var nums = $$('[data-count]', box), raf;
      function fmt(n, v) { return v + (n.getAttribute('data-suffix') || ''); }
      if (!('IntersectionObserver' in window)) { nums.forEach(function (n) { n.textContent = fmt(n, n.getAttribute('data-count')); }); return; }
      function run() {
        cancelAnimationFrame(raf);
        var t0 = performance.now();
        (function tick(now) {
          var p = Math.min(1, (now - t0) / 1600), e = 1 - Math.pow(1 - p, 3);
          nums.forEach(function (n) { n.textContent = fmt(n, Math.round(Number(n.getAttribute('data-count')) * e)); });
          if (p < 1) raf = requestAnimationFrame(tick);
        })(t0);
      }
      new IntersectionObserver(function (en) {
        if (en[0].isIntersecting) run();
        else { cancelAnimationFrame(raf); nums.forEach(function (n) { n.textContent = fmt(n, 0); }); }
      }, { threshold: 0.35 }).observe(box);
    });
  }

  /* etapes "how it works" en lecture auto */
  function steps(ctx) {
    $$('[data-rwpp-steps]', ctx).forEach(function (wrap) {
      if (!once(wrap, 'steps')) return;
      var sec = wrap.closest('.rwpp-how') || wrap.parentNode;
      var sts = $$('.rwpp-st', wrap), imgs = $$('.rwpp-how__media img', sec), lbl = sec.querySelector('[data-rwpp-how-n]');
      var MS = Number(wrap.getAttribute('data-ms')) || 6000, cur = 0, tm = null, paused = false, left = MS, t0 = 0;
      if (!sts.length) return;
      wrap.style.setProperty('--ms', MS + 'ms');
      function schedule() { clearTimeout(tm); if (paused) return; t0 = Date.now(); tm = setTimeout(function () { go((cur + 1) % sts.length); }, left); }
      function go(i) {
        cur = i;
        sts.forEach(function (s, k) {
          s.classList.toggle('is-on', k === i);
          s.setAttribute('aria-expanded', k === i ? 'true' : 'false');
          var b = s.querySelector('.rwpp-st__bar');
          if (!b) return;
          b.classList.remove('is-run'); void b.offsetWidth;
          if (k === i) b.classList.add('is-run');
        });
        imgs.forEach(function (m, k) { m.classList.toggle('is-on', k === i); });
        if (lbl) lbl.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
        left = MS; schedule();
      }
      sts.forEach(function (s, k) { s.addEventListener('click', function () { go(k); }); });
      sec.addEventListener('mouseenter', function () { paused = true; clearTimeout(tm); left = Math.max(0, left - (Date.now() - t0)); wrap.classList.add('is-paused'); });
      sec.addEventListener('mouseleave', function () { paused = false; wrap.classList.remove('is-paused'); schedule(); });
      go(0);
    });
  }

  /* barre d'achat fixe : reprend le prix du bouton principal et y ramene */
  function sticky(ctx) {
    $$('[data-rwpp-sticky]', ctx).forEach(function (bar) {
      if (!once(bar, 'sticky')) return;
      var btn = bar.querySelector('[data-rwpp-sticky-atc]'), priceEl = bar.querySelector('[data-rwpp-sticky-price]');
      function mainBtn() { return document.querySelector('.rwpp-atc-form [type="submit"]'); }
      function mainPrice() { return document.querySelector('.rwpp-atc-form [data-tcs-price]'); }
      function sync() {
        var p = mainPrice();
        if (priceEl && p) priceEl.textContent = p.textContent.trim();
      }
      function onScroll() {
        var m = mainBtn();
        var on = m ? m.getBoundingClientRect().bottom < 0 : window.pageYOffset > 800;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) sync();
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('change', sync);
      document.addEventListener('click', function () { setTimeout(sync, 80); });
      /* Le clic ramene au vrai bouton au lieu d'ajouter par script : l'app de popup upsell renvoie sinon
         le formulaire une seconde fois et le panier recoit un doublon (constate le 2026-10-15). */
      if (btn) btn.addEventListener('click', function () {
        var target = document.querySelector('#rwpp-product [data-rwpp-buy]') || mainBtn();
        if (!target) return;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - headerOffset(), behavior: 'smooth' });
        var m = mainBtn();
        if (m) { m.classList.remove('is-pulse'); void m.offsetWidth; m.classList.add('is-pulse'); }
      });
      onScroll(); setTimeout(sync, 1500);
    });
  }

  /* frise "What to expect" : chaque etape apparait quand on arrive dessus, et se rejoue a chaque passage */
  function timeline(ctx) {
    $$('.rwpp-tl', ctx).forEach(function (tl) {
      if (!once(tl, 'tl')) return;
      if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      tl.classList.add('is-anim');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) e.target.classList.add('is-in');
          /* repasse en attente seulement quand l'etape est sortie par le bas (on est remonte au-dessus) */
          else if (e.boundingClientRect.top > 0) e.target.classList.remove('is-in');
        });
      }, { threshold: 0, rootMargin: '0px 0px -18% 0px' });
      $$('.rwpp-tl__i', tl).forEach(function (el) { io.observe(el); });
    });
  }

  /* routine : les etapes restent a leur place ; une copie agrandie de l'etape active part de sa vignette
     et vient se poser au centre, par-dessus les autres */
  function routine(ctx) {
    $$('[data-rwpp-rtc]', ctx).forEach(function (box) {
      if (!once(box, 'rtc')) return;
      var area = box.querySelector('.rwpp-rtc__area'), grid = box.querySelector('.rwpp-rt'), stage = box.querySelector('.rwpp-rtc__stage');
      var items = $$('.rwpp-rt__i', grid), dots = $$('.rwpp-rtc__dots button', box);
      var MS = Number(box.getAttribute('data-ms')) || 5000, cur = 0, tm = null, visible = false, hover = false;
      var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!items.length || !stage) return;
      box.style.setProperty('--ms', MS + 'ms');
      function fit() {
        /* laisse assez de hauteur pour la carte agrandie */
        area.style.paddingTop = area.style.paddingBottom = '0px';
        var pad = Math.max(0, (stage.offsetHeight - grid.offsetHeight) / 2 + 12);
        area.style.paddingTop = area.style.paddingBottom = pad + 'px';
      }
      function show(fromEl) {
        var src = items[cur];
        stage.innerHTML = '';
        var card = document.createElement('div');
        card.className = 'rwpp-rtc__card';
        $$('.rwpp-rt__m, .rwpp-rt__h, p', src).forEach(function (n) { card.appendChild(n.cloneNode(true)); });
        stage.appendChild(card);
        fit();
        if (still || !fromEl) return;
        var a = area.getBoundingClientRect(), r = fromEl.getBoundingClientRect(), f = stage.getBoundingClientRect();
        var dx = (r.left + r.width / 2) - (f.left + f.width / 2), dy = (r.top + r.height / 2) - (f.top + f.height / 2);
        var sc = r.width / f.width;
        stage.style.transition = 'none';
        stage.style.transform = 'translate(-50%,-50%) translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ')';
        stage.style.opacity = '.4';
        void stage.offsetWidth;
        stage.style.transition = '';
        stage.style.transform = '';
        stage.style.opacity = '';
      }
      function go(i, animate) {
        cur = (i + items.length) % items.length;
        items.forEach(function (it, k) { it.classList.toggle('is-on', k === cur); });
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === cur); d.querySelector('span').classList.remove('is-run'); });
        show(animate === false ? null : items[cur]);
        schedule();
      }
      function schedule() {
        clearTimeout(tm);
        var bar = dots[cur] && dots[cur].querySelector('span');
        if (bar) { bar.classList.remove('is-run'); void bar.offsetWidth; }
        if (!visible || hover || document.hidden) return;
        if (bar) bar.classList.add('is-run');
        tm = setTimeout(function () { go(cur + 1); }, MS);
      }
      items.forEach(function (it, k) { it.addEventListener('click', function () { if (!moved && k !== cur) go(k); }); });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); }); });
      var pv = box.querySelector('[data-rwpp-rtc-prev]'), nx = box.querySelector('[data-rwpp-rtc-next]');
      if (pv) pv.addEventListener('click', function () { go(cur - 1); });
      if (nx) nx.addEventListener('click', function () { go(cur + 1); });
      area.addEventListener('mouseenter', function () { hover = true; schedule(); });
      area.addEventListener('mouseleave', function () { hover = false; schedule(); });
      document.addEventListener('visibilitychange', schedule);
      /* swipe au doigt, glisser a la souris, et balayage horizontal du trackpad (une etape par geste) */
      var px = null, py = null, pid = null, moved = false;
      area.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        px = e.clientX; py = e.clientY; pid = e.pointerId; moved = false;
        if (e.pointerType === 'mouse' && area.setPointerCapture) { try { area.setPointerCapture(pid); } catch (err) {} }
      });
      area.addEventListener('pointermove', function (e) { if (px !== null && e.pointerId === pid && Math.abs(e.clientX - px) > 8) moved = true; });
      function endSwipe(e) {
        if (px === null || e.pointerId !== pid) return;
        var dx = e.clientX - px, dy = e.clientY - py; px = null; pid = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.2) go(cur + (dx < 0 ? 1 : -1));
      }
      area.addEventListener('pointerup', endSwipe);
      area.addEventListener('pointercancel', function () { px = null; pid = null; });
      area.addEventListener('lostpointercapture', function () { px = null; pid = null; });
      area.addEventListener('dragstart', function (e) { e.preventDefault(); });
      var acc = 0, lastW = 0, locked = false, unlock = null;
      area.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
        e.preventDefault();
        /* apres un passage, on ignore la traine d'inertie jusqu'a 250 ms sans evenement */
        clearTimeout(unlock);
        unlock = setTimeout(function () { locked = false; acc = 0; }, 250);
        if (locked) return;
        var now = Date.now();
        if (now - lastW > 200) acc = 0;
        lastW = now; acc += e.deltaX;
        if (Math.abs(acc) > 50) { locked = true; go(cur + (acc > 0 ? 1 : -1)); acc = 0; }
      }, { passive: false });
      window.addEventListener('resize', fit);
      $$('img', grid).forEach(function (im) { if (!im.complete) im.addEventListener('load', fit); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var was = visible; visible = en[0].isIntersecting;
          if (visible && !was) go(0); else schedule();
        }, { threshold: 0.15 }).observe(box);
      } else { visible = true; }
      box.classList.add('is-ready');
      go(0, false);
    });
  }

  function init(ctx) { accordions(ctx); gallery(ctx); results(ctx); stats(ctx); steps(ctx); sticky(ctx); timeline(ctx); routine(ctx); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
